import { useState, useEffect } from "react";
import { sizes } from "../../theme/theme";
import { useTheme, useMediaQuery } from "@mui/material";

const useWindowSize = ({ withNavBar = true } = {}) => {
  const theme = useTheme();
  const [windowSize, setWindowSize] = useState({
    width: null,
    height: null
  });

  // True when width of screen is less than XS breakpoint in theme
  const xsDown = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight - (withNavBar ? sizes.topNavBarHeight : 0)
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { windowSize, xsDown };
};

export default useWindowSize;
